import { ActionTableState } from "../../action-table/action-table";
import AssignmentTable from "../../fragments/assignment-table";

function CustomerAssignmentList({ customerId }) {
  return <div style={{ height: '100%', overflow: "auto"}}><AssignmentTable as={ActionTableState} preselectedCustomerId={customerId} /></div>
}

export default CustomerAssignmentList;